import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { FingerprintResult, EmbedResult } from '../types';

export const fingerprintService = {
  // Embeber fingerprint en un archivo
  embedFingerprint: async (file: File, clientId: string): Promise<EmbedResult> => {
    try {
      const embedFingerprint = httpsCallable(functions, 'embedFingerprint');
      
      // Convertir archivo a base64
      const base64 = await fileToBase64(file);
      
      const result = await embedFingerprint({
        fileData: base64,
        fileName: file.name,
        fileType: file.type,
        clientId: clientId
      });
      
      return result.data as EmbedResult;
    } catch (error) {
      console.error('Error embedding fingerprint:', error);
      throw error;
    }
  },

  // Verificar fingerprint en un archivo
  verifyFingerprint: async (file: File, clientId: string): Promise<FingerprintResult> => {
    try {
      const verifyFingerprint = httpsCallable(functions, 'verifyFingerprint');
      
      // Convertir archivo a base64
      const base64 = await fileToBase64(file);
      
      const result = await verifyFingerprint({
        fileData: base64,
        fileName: file.name,
        fileType: file.type,
        clientId: clientId
      });
      
      return result.data as FingerprintResult;
    } catch (error) {
      console.error('Error verifying fingerprint:', error);
      throw error;
    }
  }
};

// Función auxiliar para convertir archivo a base64
const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result as string;
      // Remover el prefijo "data:application/octet-stream;base64,"
      const base64Data = base64.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = error => reject(error);
  });
};
